import type { Sides } from "@project/emerge-types";
import type * as THREE from "three";
import type { CornerType } from "../interfaces/CornerType";
import type {
  InboardRollerType,
  OutboardRollerType,
} from "../interfaces/RollerBoardProperties";
import type { EdgeInfos } from "./EdgeInfos";
import { DefaultGroupName } from "./Rect";

export class CornerInfos {
  public sides: Sides[];
  public edges: EdgeInfos[];
  public position: THREE.Vector3;
  public useLVariant: boolean;
  public group: string;
  public mirror = false;
  public partSelection:
    | CornerType
    | OutboardRollerType
    | InboardRollerType
    | null;
  constructor(
    sideX: Sides,
    sideY: Sides,
    sideZ: Sides,
    position: THREE.Vector3,
    group: string = DefaultGroupName,
    partSelection: CornerType | null = null,
  ) {
    this.sides = [sideX, sideY, sideZ];
    this.position = position;
    this.group = group;
    this.edges = [];
    this.useLVariant = false;
    this.partSelection = partSelection;
  }
  // public getNextCW(edge: EdgeInfos) {
  //     const remainingEdges = _.without(this.edges, edge);
  //     return edge.start.pos.copy().cross(remainingEdges.)
  // }
}
